<script lang="ts">
    import type {LoanRequestOption} from 'src/typings';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import {getLoanRequestFormContext} from '../../context';

    export let apiPath: string;
    export let option: LoanRequestOption;
    export let isDisabled = false;
    export let dataQa: string | null = null;

    const {sendLoanRequest} = getLoanRequestFormContext();
</script>

<div class="send-loan-request-button-container">
    <KpButton buttonStyle="primary"
              {isDisabled}
              {dataQa}
              on:click={() => sendLoanRequest(apiPath, option)}>
        <slot/>
    </KpButton>
</div>

<style lang="less">
    .send-loan-request-button-container {
        align-self: center;
    }
</style>